const topics = [
  {
    title: "---Non Standard---",
    subtitle1: "Topic: 1",
    description: "PS.1.1 Understand how forces (pushes or pulls) affect the motion of an object.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnonstandard2025video.mp4?alt=media&token=3ca13e28-627b-4026-a3f3-0f7446b80b3c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnonstandard2025song.mp3?alt=media&token=e2129e68-0a2d-4d0c-9a3a-b0063dcbd98c",
    lyrics: [
      "(chorus)",
"These are my nonstandard units of measurement.",
"Just to get an idea of how big something is.",
"These are my nonstandard units of measurement.",
"Just to get an idea of how big something is.",

"(verse)",
"We can use anything to measure something.",
"We can use anything to measure something.",

"I measured my speaker and it equaled 1 sneaker.",
"I measured my chair and it equaled 5 stairs.",
"I measured my cup and it equaled 2 thumbs.",
"I measured my fan and it equaled 3 hands.",

"We can use anything to measure something.",
"We can use anything to measure something.",

"(chorus)",
"These are my nonstandard units of measurement.",
"Just to get an idea of how big something is.",
"These are my nonstandard units of measurement.",
"Just to get an idea of how big something is.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Telling Time---",
    subtitle1: "Topic: 2",
    description: "PS.1.1 Understand how forces (pushes or pulls) affect the motion of an object.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftellingtime2025video.mp4?alt=media&token=9d27ffc5-5101-4905-821e-bf1d47cdbaeb",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftellingtime2025song.mp3?alt=media&token=117307c5-e509-4003-a294-7cbb49f997d4",
    lyrics: ["(chorus)",
"We can tell time, tell time, tell time.",
"We can tell time, tell time, tell time.",

"(verse)",
"Now, all clocks are broken down",
"into minutes and hours.",
"The little hand is the hour,",
"it tells us what the hour is.",
"When the little hand hits one, it’s 1 o’clock.",
"When the little hand hits two, it’s 2 o’clock.",
"When the little hand hits three, it’s 3 o’clock.",
"When the little hand hits four, it’s 4 o’clock.",

"Now, the big hand tells us the minutes.",
"Each notch is one minute.",
"Each number is five minutes.",
"When the big hand hits one, that’s 5 minutes.",
"When the big hand hits two, that’s 10 minutes.",
"When the big hand hits three, that’s 15 minutes.",
"When the big hand hits four, that’s 20 minutes.",

"(chorus)",
"We can tell time, tell time, tell time.",
"We can tell time, tell time, tell time.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "---Dollars and Cents---",
    subtitle1: "Topic: 3",
    description: "PS.1.1 Understand how forces (pushes or pulls) affect the motion of an object.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdollarsandcents2025video.mp4?alt=media&token=8454884b-b9ba-441b-9134-ca432c7319a0",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdollarsandcents2025song.mp3?alt=media&token=97c2923e-18ea-41d1-8e22-8407ff969cc6",
    lyrics: [
      "(Chorus)",
"Make dollars, make cents.",
"Make dollars, make cents.",
"Let’s make dollars, make cents.",
"Let’s make dollars, make cents.",

"(Verse)",
"One penny is 1 cent, one penny is 1 cent.",
"The face on the front is Abraham Lincoln.",
"He was our 16th president.",
"One nickel is 5 cents, one nickel is 5 cents.",
"The face on the front is Thomas Jefferson.",
"He was our 3rd president.",
"One dime is 10 cents, one dime is 10 cents.",
"The face on the front is Franklin Roosevelt.",
"He was our 32nd president.",
"One quarter is 25 five cents, one quarter is 25 five cents.",
"The face on the front is George Washington.",
"He was our 1st president.",

"(Chorus)",
"Make dollars, make cents.",
"Make dollars, make cents.",
"Let’s make dollars, make cents.",
"Let’s make dollars, make cents.",

"(Verse)",
"Now, one penny is 1 cent, so 100 pennies is one dollar.",
"One nickel is 5 cents, so 20 nickels is one dollar.",
"One dime is 10 cents, so 10 dimes is one dollar.",
"One quarter is 25 cents, so 4 quarters is one dollar.",

"(Chorus)",
"Make dollars, make cents.",
"Make dollars, make cents.",
"Lets make dollars, make cents.",
"Lets make dollars, make cents.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Shapes---",
    subtitle1: "Topic: 4",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fshapes2025video.mp4?alt=media&token=d30cea74-886b-46e5-93ee-4b24a068576b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fshapes2025song.mp3?alt=media&token=3bb352c7-b9a4-46f3-91ad-f79f638945f9",
    lyrics: [
     "(chorus)",
"These are my shapes.",
"These are my shapes.",
"These are my shapes.",
"How many sides do they have?",

"(verse)",
"A triangle has 3 sides.",
"A rectangle has 4 sides.",
"A square has 4 sides.",
"A pentagon has 5 sides.",
"A hexagon has 6 sides.",
"An octagon has 8 sides.",

"(chorus)",
"These are my shapes.",
"These are my shapes.",
"These are my shapes.",
"How many sides do they have?",

"(verse)",
"A triangle has 3 sides.",
"A rectangle has 4 sides.",
"A square has 4 sides.",
"A pentagon has 5 sides.",
"A hexagon has 6 sides.",
"An octagon has 8 sides.",

"(chorus)",
"These are my shapes.",
"These are my shapes.",
"These are my shapes.",
"How many sides do they have?",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Place Value---",
    subtitle1: "Topic: 5",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplacevalue2025video.mp4?alt=media&token=3f9c9c42-f584-47e7-bcdd-b83c8aa7fbbc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplacevalue2025song.mp3?alt=media&token=847038d3-72ea-4c54-9645-9ef01971073e",
    lyrics: [
     "(intro)",
"Place value.",
"Place value.",

"(chorus)",
"As we go to the left,",
"each place value goes up 10 times.",
"As we go to the left,",
"each place value goes up 10 times.",

"(verse)",
"In our number system",
"the value depends on the place or position",
"of a number, of a number.",
"In our number system",
"the value depends on the place or position",
"of a number, of a number.",

"Ones place.",
"Tens place.",
"Hundreds place.",
"Thousands place.",
"Ten thousands place.",
"Hundred thousands place.",
"Millions place.",

"Ones place.",
"Tens place.",
"Hundreds place.",
"Thousands place.",
"Ten thousands place.",
"Hundred thousands place.",
"Millions place.",

"(chorus)",
"As we go to the left,",
"each place value goes up 10 times.",
"As we go to the left,",
"each place value goes up 10 times.",

"(outro)",
"Place value.",
"Place value.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "---Greater Than Less Than---",
    subtitle1: "Topic: 6",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fgreaterthan2025video.mp4?alt=media&token=5f83b245-64f5-4996-8ce7-007211772077",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fgreaterthanlessthan2025song.mp3?alt=media&token=680d1faa-4910-4495-9fe2-dcde359b0bd5",
    lyrics: [
      "(Chorus)",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",

"(Verse)",
"The greater than and less than symbol, let’s call it an alligator.",
"An alligator that’s hungry and he only eat numbers that’s greater.",
"When his mouth is open it faces the larger number.",
"So, the closed side is less than and the open side is greater.",
"If there’s an equal sign between two numbers, then they’re equal.",
"If there’s an equal sign between two numbers, then they’re equal.",

"(Chorus)",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",
"Less than, greater than, equal to, equal to.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "---3 Time Tables Rock---",
    subtitle1: "Topic: 7",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3timetablesrock2023.mp4?alt=media&token=47d85c19-fa53-412e-a361-2a392c8918c0",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3%20TIME%20TABLES%20ROCK.mp3?alt=media&token=92835c2f-8b53-4f7c-bef9-f9e0c244a69d",
    lyrics: ["(Chorus)",
"Let’s do our 3 timetables, let’s do our 3 timetables.",
"Rock these tables, rock these tables.",
"Let’s do our 3 timetables, let’s do our 3 timetables.",
"Rock these tables, rock these tables.",

"(Bridge)",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",

"(Verse)",
"3 x 1 = 1",
"3 x 2 = 6",
"3 x 3=9",
"It’ll be 9 all the time.",
"3 x 4=12",
"3 x 5=15",
"3 x 6=18",
"Keep fresh kicks on and they stay clean.",
"3 x 7=21",
"3 x 8=24",
"3 x 9=27",
"Make the world feel like heaven.",
"3 x 10=30",
"3 x 11=33",
"3 x 12=36",
"Timetables put me in the mix.",

"(Chorus)",
"Let’s do our 3 timetables, let’s do our 3 timetables.",
"Rock these tables, rock these tables.",
"Let’s do our 3 timetables, let’s do our 3 timetables.",
"Rock these tables, rock these tables.",

"(Bridge)",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",
"3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---6 Time Tables Rock---",
    subtitle1: "Topic: 8",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F6timetablesrock2023.mp4?alt=media&token=8d13212a-a66a-4db6-8425-1abe94ba01c8",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F6%20TIME%20TABLES%20ROCK.mp3?alt=media&token=1250e76c-5cc7-4489-bc90-8c2a7b77871e",
    lyrics: ["(Bridge)",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",

"(Chorus)",
"6 timetables, 6 timetables.",
"6 timetables, 6 timetables.",

"(Verse)",
"6 x 1 is 6, we’re on a roll.",
"6 x 2 is 12, this we know.",
"6 x 3 is 18, get it right.",
"6 x 4 is 24, aim for the sky.",
"6 x 5 is 30, the right turns.",
"6 x 6 is 36, we learn.",
"6 x 7 is 42, right again.",
"6 x 8 is 48, my writer's pen.",
"6 x 9 is 54, stay on point.",
"6 x 10 is 60, this is my joint.",

"(Chorus)",
"6 timetables, 6 timetables.",
"6 timetables, 6 timetables.",

"(Bridge)",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",
"6, 12, 18, 24, 30, 36, 42, 48, 54, 60.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "---10 Time Tables Rock---",
    subtitle1: "Topic: 9",
    description: "LS.1.1 Understand the basic needs of a variety of plants and animals in different ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F10timetablesrock2023.mp4?alt=media&token=c13bc5ae-de41-4146-9900-c04c1ba7ede6",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F10%20TIME%20TABLES%20ROCK.mp3?alt=media&token=8af500a5-6d9e-445a-9a2d-a87e1fb4d271",
    lyrics: ["(Chorus)",
"10 times any number,",
"You put a zero after that number, you get it.",
"10 times any number,",
"You put a zero after that number, you get it.",

"(Verse 1)",
"10x1 is 10,",
"You put a zero after the 1, you get 10.",
"10x2 is 20,",
"You put a zero after the 2, you get 20.",

"(Bridge 1)",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",

"(Verse 2)",
"10x4 is 40,",
"You put a zero after the 4, you get 40.",
"10x5 is 50,",
"You put a zero after the 5, you get 50.",

"(Bridge 2)",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",

"© Smart Board Learning, LLC. All rights reserved.",],
    game: "https://example.com/game-force",
    titleImage: "", // Empty string means no image for Force
  },
];
export default topics;